import axios from 'axios';

// Set default base URL for all requests
axios.defaults.baseURL = 'https://backend.alsahaba.sa';  // Your API base URL

// Set default headers for all requests
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default axios;
